import { CanActivateFn } from '@angular/router';
import { IdentityService } from '../identity.service';
import { inject } from '@angular/core';
import { map } from 'rxjs';

export const myDelegationsGuard: CanActivateFn = () => {
    const identityService: IdentityService = inject(IdentityService);
    return identityService.user$.pipe(
        map((response: { impersonation?: boolean }) => (response?.impersonation ? false : true))
    );
};
